/**
 *
 *  ? url pada submenu menggunakana naming routes,
 *  ? jadi tidak perlu dibuat format url lengkap
 */

export default [
  {
    icon: "ListIcon",
    menu: "Internal",
    url: "lppm-penelitian-pengabdian-internal",
  },
  {
    icon: "ListIcon",
    menu: "Mandiri",
    url: "lppm-penelitian-pengabdian-mandiri",
  },
  {
    icon: "ListIcon",
    menu: "Publikasi Dosen",
    url: "lppm-publikasi-dosen",
  },
];
